import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { BillingPolicy } from './billing-policy';
import { Currency } from './currency.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { CurrencyConfig } from 'src/app/shared/tools/search/search-config';

@Resource({
  type: 'orderedsequencerules',
})
export class OrderedSequenceRule extends AtomResource {
  @Attribute() step?: number;
  @Attribute() price?: number;
  @Attribute() tries?: number;
  @Attribute({ key: 'next_try' }) nextTry?: string;
  @Attribute({ key: 'next_rule' }) nextRule?: string;
  @Attribute() data?: Record<string, unknown>;

  @Relationship() currency?: Currency;
  @Relationship() billingpolicy?: BillingPolicy;
}

export class OrderedsequenceruleConfig implements ResourceConfig {
  hosted = 'billingpolicy';
  ordered = true;
  tables = {
    options: {
      copy: true,
    },
    includes: ['currency', 'billingpolicy'],
    columns: [
      {
        columnDef: 'step',
        displayedDatas: [
          { path: ['step'], class: 'main', translatable: false },
        ],
        header: 'Step',
        displayed: true,
        orderColumn: 'step',
      },
      {
        columnDef: 'price',
        displayedDatas: [
          {
            path: ['price', 'currency.name'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Price',
        displayed: true,
      },
      {
        columnDef: 'tries',
        displayedDatas: [
          { path: ['tries'], class: 'mat-body-2', translatable: false },
        ],
        header: 'tries',
        displayed: true,
      },
      {
        columnDef: 'nextTry',
        displayedDatas: [
          { path: ['nextTry'], class: 'mat-body-2', interval: true },
        ],
        header: 'Next Try',
        displayed: true,
      },
      {
        columnDef: 'nextRule',
        displayedDatas: [
          { path: ['nextRule'], class: 'mat-body-2', interval: true },
        ],
        header: 'Next Rule',
        displayed: true,
      },
      {
        columnDef: 'data',
        displayedDatas: [
          { path: ['data'], class: 'mat-body-2', interval: true },
        ],
        header: 'Data',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  wizard = {
    linear: false,
    tabs: [
      {
        title: 'Order Sequence',
        formGroup: 'ordersequence',
        list: [
          {
            type: 'order',
            title: 'Step',
            formControl: 'step',
            APIKey: 'step',
            required: true,
            notEditable: true,
          },
          {
            type: 'number',
            title: 'Price',
            formControl: 'price',
            APIKey: 'price',
          },
          {
            type: 'resource',
            title: 'Currency',
            formControl: 'currency',
            APIKey: 'currency',
            multiple: false,
            required: true,
            search: new CurrencyConfig(),
            filter: [
              {
                key: 'like.countries.id',
                value: 'billingpolicy.country.id',
              },
            ],
          },
          {
            type: 'number',
            title: 'Tries',
            formControl: 'tries',
            APIKey: 'tries',
            required: true,
          },
          {
            type: 'interval',
            title: 'Next Try',
            formControl: 'nextTry',
            APIKey: 'nextTry',
          },
          {
            type: 'interval',
            title: 'Next Rule',
            formControl: 'nextRule',
            APIKey: 'nextRule',
          },
        ],
      },
      {
        title: 'Data',
        formGroup: 'data',
        list: [
          {
            type: 'data',
            title: 'Data',
            formControl: 'data',
            required: false,
          },
        ],
      },
    ],
  };
  resource = OrderedSequenceRule;
  resourceName = 'Ordered Sequence Rules';
  resourceKey = 'orderedsequencerules';
  resourceKeySingle = 'orderedsequencerule';
  includes = ['currency', 'billingpolicy'];
  filters = [];
}
